import { Route, Routes } from "react-router-dom";

import SetupAccount from "containers/SetupAccount";
import useBoundStore from "store";
import DesktopPrivateRoutes from "../../../routes/DesktopPrivateRoutes";
import MobilePrivateRoutes from "../../../routes/MobilePrivateRoutes";

function RoutesWrapper() {
  const userAuth = useBoundStore((state) => state.user.auth);
  const isMobileDevice = useBoundStore((state) => state.miscellaneous.isMobileDevice);

  if (userAuth && !userAuth?.profileCreated) {
    return (
      <Routes>
        <Route path='/' element={<SetupAccount />} />
      </Routes>
    );
  }

  return isMobileDevice ? <MobilePrivateRoutes /> : <DesktopPrivateRoutes />;
}

export default RoutesWrapper;
